import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FilterByActivityPipe } from "./filter-by-activity.pipe";
import { GetAddressNamePipe } from "./get-address-name.pipe";
import { GetCareplanDescriptionPipe } from "./get-careplan-description.pipe";
import { IsProcedureActivityPipe } from "./isProcedureActivity.pipe";
import { TranslationReadyPipe } from "./translation-ready.pipe";

@NgModule({
  declarations: [FilterByActivityPipe, GetAddressNamePipe, GetCareplanDescriptionPipe, IsProcedureActivityPipe, TranslationReadyPipe],
  imports: [CommonModule],
  exports: [FilterByActivityPipe, GetAddressNamePipe, GetCareplanDescriptionPipe, IsProcedureActivityPipe, TranslationReadyPipe],
})
export class CareplanEditorPipesModule {}
